import { render, staticRenderFns } from "./ArtistBadgeList.vue?vue&type=template&id=c4d34618&scoped=true&"
import script from "./ArtistBadgeList.vue?vue&type=script&lang=js&"
export * from "./ArtistBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistBadgeList.vue?vue&type=style&index=0&id=c4d34618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d34618",
  null
  
)

export default component.exports